var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightRoundedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.2207C6.26801 28.2207 9.21617e-08 21.9527 2.05849e-07 14.2207C3.19536e-07 6.48872 6.26801 0.220703 14 0.220703L18 0.220703C25.732 0.220703 32 6.48872 32 14.2207C32 21.9527 25.732 28.2207 18 28.2207L14 28.2207Z",
    fill: "#E2E5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7381 12.8204L8.80078 12.8204L8.80078 15.6424L17.7381 15.6424L14.5381 18.4645L16.8008 20.46L23.8636 14.2314L16.8008 8.00284L14.5381 9.99833L17.7381 12.8204Z",
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRoundedIcon);
export default __webpack_public_path__ + "static/media/arrow-right-rounded-icon.70430e0286f8fb97464e089838eac1fd.svg";
export { ForwardRef as ReactComponent };